import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

export interface IGetAccommodationRatePlanPrice {
  rate_plan_id?: number;
  unit_type_id?: number;
  start_date?: string;
  end_date?: string;
}

export interface IAccommodationRatePlanPrice {
  id: number;
  rate_plan_id: number;
  unit_type_id: number;
  date: string;
  price: number;
  min_los: number | null;
  max_los: number | null;
  closed_to_arrival: boolean;
  closed_to_departure: boolean;
  closed: boolean;
}

export interface IPostAccommodationRatePlanPrice {
  rate_plan_id: number;
  unit_type_id: number;
  price: number;
  date: Date;
}

export interface IPutAccommodationRatePlanPrice {
  rate_plan_price_id: number;
  min_los?: number;
  max_los?: number;
  closed_to_arrival?: boolean;
  closed_to_departure?: boolean;
  closed?: boolean;
  price?: number;
  rate_plan_price_ids?: number[];
}

// GET Accommodation Rate Plans
export async function GetAccommodationRatePlanPrices(params: IGetAccommodationRatePlanPrice, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan/price"), params, useGlobalLoader);
}

// POST Accommodation Rate Plan
export async function PostAccommodationRatePlanPrices(params: IPostAccommodationRatePlanPrice, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan/price"), params, useGlobalLoader);
}

// PUT Accommodation Rate Plan
export async function PutAccommodationRatePlanPrice(params: IPutAccommodationRatePlanPrice, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan/price"), params, useGlobalLoader);
}
